import {ChangeDetectionStrategy, Component, inject, input, output, signal} from '@angular/core';
import {UserRepositoryService} from '@xmedical/core';
import {FormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';

@Component({
    selector: 'xui-lock',
    templateUrl: './app-lock.component.html',
    styleUrls: ['./app-lock.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatFormFieldModule, MatInputModule, MatButtonModule]
})
export class AppLockComponent {

  private userRepository = inject(UserRepositoryService);

  readonly idleTimeout = input<number>();
  readonly userEmail = input('');
  readonly login = output<boolean>();
  readonly logout = output<boolean>();

  password = '';
  passwordFieldType = 'password';
  readonly errorMessage = signal('');
  readonly validated = signal(false);

  get fieldValid(): boolean {
    return this.password.length > 0 && this.errorMessage() === '';
  }

  get timeoutDuration(): string {
    return (this.idleTimeout() ?? 0).toString();
  }

  get emailAddress(): string {
    return this.userEmail();
  }

  get passwordVisible(): boolean {
    return this.passwordFieldType !== 'password';
  }

  togglePasswordVisibility() {
    this.passwordFieldType = (this.passwordVisible) ? 'password' : 'text';
  }

  onLogout() {
    this.logout.emit(true);
  }

  onClick() {
    this.validated.set(true);
    this.errorMessage.set('');
    this.userRepository.verifyUserCredentials(this.password).subscribe({
      next: result => {
        if (result) {
          this.login.emit(true);
        } else {
          this.errorMessage.set('Could not verify user credentials');
        }
      },
      error: error => {
        console.error(error);
        this.errorMessage.set('Could not verify user credentials');
      }
    });
  }
}
